import React, { useState } from 'react'
import BreadcrumbHeader from '../../layout/BreadcrumbsHeader'
import { useTheme } from '@emotion/react'
import ThemeBGWrapper from '../../ui-components/ThemeBGWrapper'
import { Primary } from '../../ui-components/Buttons';import { Add, ContentCopyOutlined, FileCopy, OpenInNew } from '@mui/icons-material'
import { Box, Button, Card, CardContent, CardHeader, CircularProgress, Divider, Grid, IconButton, LinearProgress, Menu, MenuItem, Tooltip, Typography, useMediaQuery } from '@mui/material'
import fundingRoundsBackground from "../../assets/rounds_icons/funding_rounds_background.webp"
import { FetchAllRounds } from '../../api/round'
import { ReactComponent as SecurityIcon } from "../../assets/rounds_icons/security_icon.svg"
import { ReactComponent as ViewIcon } from "../../assets/rounds_icons/view_icon.svg"
import { ReactComponent as MoreIcon } from "../../assets/rounds_icons/more_icon.svg"
import { useNavigate } from 'react-router-dom'
import rocket_rounds_image from "../../assets/rounds_icons/rocket_rounds_image.png"
import PerfectScrollbar from "react-perfect-scrollbar"
import moment from 'moment'
import { containerRef, handleCopyClick, handleDateValues } from '../../utils'
import { FetchAllAvatars, FetchProfileDetails } from '../../api'
import { TabContext, TabPanel } from '@mui/lab'
import CustomTabs from '../../ui-components/CustomTabs'
import { makeStyles } from '@mui/styles'
import PersonalDetails from './PersonalDetails'
import NeedHelpButton from 'ui-components/NeedHelpButton'
import Cookies from 'js-cookie'

const useStyles = makeStyles((theme) => ({
  scrollTabs: {
    '& > .Mui-disabled.MuiTabs-scrollButtons': {
      display: 'none',
      transition: 'all 1s ease'
    }
  }
}));

const Profile = () => {
  const theme = useTheme()
  const isNotLargeScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();
  const navigate = useNavigate()
  let [investor_id, setInvestorID] = React.useState(Cookies.get("X-ADMIN-ID") || null);
  const { data: userData, isLoading: isUserDataLoading } = FetchProfileDetails({ investor_id });
  // const { data: avatarList, isRefetching: isRefetchingAvatarList, isLoading: isLoadingAvatarList, refetch: refetchAvatarList } = FetchAllAvatars()

  let tabValue = new URLSearchParams(window.location.search).get("page");
  // console.log("tabl",tabValue)

  const [value, setValue] = useState(tabValue || "personal_details");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const roundTabs = [
    {
      label: "Personal Details",
      // icon: RoundDetailsIcon,
      value: "personal_details",
    },
    // {
    //   label: "Sectors",
    //   // icon: RoundInvestorsIcon,
    //   value: "sectors",
    // },
    // {
    //   label: "Stages",
    //   // icon: RoundDocumentsIcon,
    //   value: "stages"
    // }
  ]

  const [copied, setCopied] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);

  return (
    <ThemeBGWrapper>
      <BreadcrumbHeader title={() => <Box display={"flex"} alignItems={"center"}>
        Profile
        <Tooltip title={copied ? "Copied to Clipboard" : "Copy Invite URL"}>
          <IconButton sx={{ marginLeft: "0.5rem" }} onClick={() =>
            userData?.data?.invite_link && handleCopyClick(userData?.data?.invite_link, copied, setCopied)}>
            {copied ? (
              <FileCopy sx={{ height: 25 }} />
            ) : (
              <ContentCopyOutlined sx={{ height: 25 }} />
            )}
          </IconButton>
        </Tooltip>
        <Tooltip title="Open Profile URL">
          <IconButton
            onClick={() => userData?.data?.backrr_base_url && window.open(userData?.data?.backrr_base_url, '_blank')}
          >
            <OpenInNew sx={{ height: 25 }} />
          </IconButton>
        </Tooltip>
      </Box>} breadcrumbTitle='Profile' customBackgroundColor={theme.palette.customColors.indigo25} Actions={() => <NeedHelpButton />} />
      {
        isUserDataLoading || isLoading ?
          <Grid item xs={12} height={"100dvh"} sx={{ width: '100%', padding: "2rem", paddingTop: 0 }}>
            {/* <CircularProgress sx={{ color: theme?.palette.customColors.b300 }} /> */}
            {/* <Box className='skeleton' height={80}>

            </Box> */}
            <Box className='skeleton' height={"calc(100%)"} marginTop={0}>

            </Box>
          </Grid>
          :
          <>
            {userData && userData?.data &&
              <Grid xs={12} container bgcolor={""}>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                  <TabContext value={value}>
                    {/* <Box px={isSmallScreen ? "1rem" : "2rem"} bgcolor={"#fff"}>
                      <CustomTabs data={roundTabs} value={value} isSmallScreen={isSmallScreen} className={classes} handleChange={handleChange} key={"Tabs Tabs"} />
                    </Box> */}
                    <TabPanel value="personal_details" sx={{ paddingInline: 0, paddingBlock: "1rem" }}>
                      <PerfectScrollbar containerRef={containerRef} style={{ height: "calc(100dvh - 100px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                        <PersonalDetails data={userData?.data} avatarList={[]} setLoading={setLoading} />
                      </PerfectScrollbar>
                    </TabPanel>
                    {/* <TabPanel value="sectors" sx={{ paddingInline: 0, paddingTop: '0.5rem' }}>
                      <PerfectScrollbar style={{ height: '100%', maxHeight: "calc(100dvh - 180px)", paddingBottom: '0.5rem' }}>
                        <RoundInvestors currency={roundDetails?.currency || ''} />
                      </PerfectScrollbar>
                    </TabPanel>
                    <TabPanel value="stages" sx={{ paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                      <PerfectScrollbar style={{ height: "calc(100dvh - 250px)" }}>
                        <RoundDocuments data={roundDetails?.documents} />
                      </PerfectScrollbar>
                    </TabPanel> */}
                  </TabContext>
                </Box>
              </Grid>}
          </>}
    </ThemeBGWrapper>
  )
}

export default Profile